import styled from "styled-components"

const Timetable = (props: any) =>
    <div className={props.className}>
        {props.children}
    </div>

export const TimetableStyled = styled(Timetable)`
    padding: 24px;

    .ant-tabs-tab-btn {
        font-size: 20px;
    }
    
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn,
    .ant-tabs-tab:hover {
        color: #000000;
    }

    .ant-tabs-ink-bar {
        background-color: #e98a2d;
    }

    .ant-tabs-top > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-bottom > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top > div > .ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-bottom > div > .ant-tabs-nav .ant-tabs-ink-bar {
        height: 4px;
    }

    .ant-form-item-label > label {
        font-weight: bold;
        height: 100%;
    }

    .title {
        font-size: 24px;
        font-weight: bold;
        display: flex;
        justify-content: center;
    }

    .trip-schedule {
        box-shadow: 0px 0px 12px rgb(0 0 0 / 15%);
        border-radius: 4px;
        padding: 12px;

        .trip-schedule-title {
            font-size: 20px;
            font-weight: bold;
        }

        .days {
            display: flex;
            gap: 12px;
            align-items: center;

            .days-title {
                font-weight: bold;
            }

            .days-active {
                color: #FFFFFF;
                background-color: #e98a2d;
                padding: 4px 8px;
                font-weight: bold;
                transform: skew(-20deg);

                > div {
                    transform: skew(20deg);
                }
            }

            .days-inactive {
                color: #000000;
                background-color: #efeeee;
                padding: 4px 8px;
                transform: skew(-20deg);
                font-weight: bold;

                > div {
                    transform: skew(20deg);
                }
            }
        }

        .hours {
            display: flex;
            gap: 12px;
            padding-top: 32px;
            flex-wrap: wrap;

            > div {
                padding: 4px;
                font-weight: bold;
                box-shadow: 0px 0px 12px rgb(0 0 0 / 15%);
            }
        }
    }

    .select-line {
        min-height: 42px;
        margin-bottom: 12px;
    }

    iframe {
        border: none;
    }

    hr {
        background-color: #EAEAEA; height: 1px; 
        border: 0;
        margin: 20px 0;
    }

    .trips-schedule {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .ant-empty {
        padding-top: 40px;
    }

    .ant-tabs-tab .anticon {
        margin-right: 6px;
        font-size: 30px;
    }
`